import React from 'react';
import Panel from 'components/Panel';
import AppRoutes from 'pages/appRoutes';

import 'globals.css';

function App() {
    return (
        <div className='app'>
            <Panel />
            <div id='page' className='page'>
                <AppRoutes />
            </div>
        </div>
    );
}

export default App;